export class GcpSqlVmBackupSettings {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "maxTransferSizeBytes",
            "baseName": "maxTransferSizeBytes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "retentionDays",
            "baseName": "retentionDays",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "logBackupIntervalMinutes",
            "baseName": "logBackupIntervalMinutes",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "fullBackupTime",
            "baseName": "fullBackupTime",
            "type": "string",
            "format": ""
        },
        {
            "name": "fullBackupIntervalDays",
            "baseName": "fullBackupIntervalDays",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "fullBackupLogPercent",
            "baseName": "fullBackupLogPercent",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "fullBackupMinLogGiB",
            "baseName": "fullBackupMinLogGiB",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "fullBackupMaxLogGiB",
            "baseName": "fullBackupMaxLogGiB",
            "type": "number",
            "format": "int64"
        }
    ];
    static getAttributeTypeMap() {
        return GcpSqlVmBackupSettings.attributeTypeMap;
    }
    constructor() {
    }
}
